import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { OktaCallbackComponent, OktaAuthGuard } from "@okta/okta-angular";
import { AppCompanyMigrationComponent } from "./views/company-migration/company-migration.component";
import { LoginComponent } from "./auth/login/login.component";
import { MigrationsComponent } from "./views/migrations/migrations.component";
import { MigrationDetailsComponent } from "./views/migration-detail/migration-details.component";
import { FalloutTrackerComponent } from "./views/fallout-tracker/fallout-tracker.component";
import { StatisticsComponent } from "./views/statistics/statistics.component";

const routes: Routes = [
  { path: "", redirectTo: "company-migration", pathMatch: "full" },
  {
    path: "company-migration",
    component: AppCompanyMigrationComponent,
    canActivate: [OktaAuthGuard],
  },
  {
    path: "migrations",
    component: MigrationsComponent,
    canActivate: [OktaAuthGuard],
  },
  {
    path: "metrics-tracker",
    component: FalloutTrackerComponent,
    canActivate: [OktaAuthGuard],
  },
  {
    path: "statistics",
    component: StatisticsComponent,
    canActivate: [OktaAuthGuard],
  },
  { path: "auth/login", component: LoginComponent },
  { path: "auth/login/callback", component: OktaCallbackComponent },
  { path: "migration/:id", component: MigrationDetailsComponent },
  { path: "**", redirectTo: "/company-migration" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
